import {
  get,
  post,
  getDynamicynamic,
  getFileUseBlobByPost,
} from "../request/http";

/**
 * 成为企业会员
 * @param {*} data
 * @returns
 */
export const becomeCrop = (data) =>
  post("/web/portal/member/become/corp/member", data);

/**
 * 成为个人会员
 * @param {*} data
 * @returns
 */
export const becomeIndividual = (data) =>
  post("/web/portal/member/become/individual/member", data);

/**
 * 成为机构会员
 * @param {*} data
 * @returns
 */
export const becomeInstitute = (data) =>
  post("/web/portal/member/become/institute/member", data);

/**
 * 成为学生会员
 * @param {*} data
 * @returns
 */
export const becomeStudent = (data) =>
  post("/web/portal/member/become/student/member", data);

/**
 * 获取会员信息
 * @param {*} data
 * @returns
 */
export const getMemberInfo = (data) => get("/web/portal/member/info", data);

/**
 * 分页查询会员列表
 * @param {*} data
 * @returns
 */
export const getMemberList = (data) => post("/web/portal/member/page", data);
